import { Observable } from 'rxjs';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { GroupModel } from 'src/app/models/archive/group.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { GroupImportModel } from 'src/app/models/imports/group-import.mode';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private _httpClient: HttpClient) { }

  createGroup(groupContractModel: GroupModel): Observable<GroupModel> {
    return this._httpClient.post<GroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.CreateGroup}`,
      groupContractModel);
  }

  deleteGroup(groupId: number): Observable<GroupModel> {
    return this._httpClient.delete<GroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.DeleteGroup}/${groupId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.group.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllGroupsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.GetAllGroupsForSelectAsync}`,);
  }

  getAllGroupsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.GetAllGroupsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getGroupById(groupId: number): Observable<GroupModel> {
    return this._httpClient.get<GroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.GetGroupById}/${groupId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.GetColumnsForGeneralConsultationAsync}`);
  }

  getGroupByCode(code: string): Observable<GroupModel> {
    const itemFilterResponse = new ItemFilterModel("code", null, null, "");
    itemFilterResponse.wildcard = code;
    return this._httpClient.post<GroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.GetGroupByCode}`, itemFilterResponse);
  }

  importGroups(groupImports: Array<GroupImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.ImportGroups}`,
      groupImports);
  }

  updateGroup(groupContractModel: GroupModel): Observable<GroupModel> {
    return this._httpClient.put<GroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.group.UpdateGroup}`,
      groupContractModel);
  }
}
